import React, { useRef, useState, useContext } from 'react'
import { NavLink, useNavigate } from 'react-router-dom';
import Assets from '../../Assets/Assets';
import './SideBar.css';
import AppContext from '../../Context/AppContext';
import { PostAPI } from '../../ApiServices/ApiServices';


const SideBar = () => {
    const [isOpen, setIsOpen] = useState(true);
    const { user, setUser } = useContext(AppContext);
    const navigate = useNavigate();

    const toggle = () => setIsOpen(!isOpen);

    const menuItem = [
        {
            path: "/",
            name: "Home",
            icon: <img className='non-active-icon' src={Assets.home} alt='Home' />,
            activeIcon: <img className='active-icon' src={Assets.active_home} alt='My Applications' />
        },
        {
            path: "/Appointments",
            name: "Appointments",
            icon: <img className='non-active-icon' src={Assets.appointment} alt='My Applications' />,
            activeIcon: <img className='active-icon' src={Assets.active_appointment} alt='My Applications' />
        },
        {
            path: "/follow-up",
            name: "Follow Up",
            icon: <img className='non-active-icon' src={Assets.appointment} alt='My Applications' />,
            activeIcon: <img className='active-icon' src={Assets.active_appointment} alt='My Applications' />
        },
         {
            path: "/my-slots",
            name: "My Slots",
            icon: <img className='non-active-icon' src={Assets.clock} alt='My Applications' />,
            activeIcon: <img className='active-icon' src={Assets.active_clock} alt='My Applications' />
        },
        // {
        //     path: "/slotsetup",
        //     name: "Slot Setup",
        //     icon: <img className='non-active-icon' src={Assets.clock} alt='My Applications' />,
        //     activeIcon: <img className='active-icon' src={Assets.active_clock} alt='My Applications' />
        // },
        {
            path: "/patients",
            name: "Patients",
            icon: <img className='non-active-icon' src={Assets.patient} alt='My Applications' />,
            activeIcon: <img className='active-icon' src={Assets.active_patient} alt='My Applications' />
        },
        // {
        //     path: "/analytics",
        //     name: "Statistics",
        //     icon: <img className='non-active-icon' src={Assets.analytics} alt='My Applications' />,
        //     activeIcon: <img className='active-icon' src={Assets.active_analytics} alt='My Applications' />
        // },
        {
            path: "/patient-engagement",
            name: "Patient Engagement",
            icon: <img className='non-active-icon' src={Assets.patient} alt='My Applications' />,
            activeIcon: <img className='active-icon' src={Assets.active_patient} alt='My Applications' />
        },
        {
            path: "/profile",
            name: "Profile",
            icon: <img className='non-active-icon' src={Assets.profile} alt='My Applications' />,
            activeIcon: <img className='active-icon' src={Assets.active_profile} alt='My Applications' />
        },
        {
            path: "/subscription-management",
            name: "Subscription Management",
            icon: <img className='non-active-icon' src={Assets.profile} alt='Subscription' />,
            activeIcon: <img className='active-icon' src={Assets.active_profile} alt='Subscription' />
        },
        {
            path: "mailto:support@digidoc.co.in",
            name: "Contact Us",
            icon: <img className='non-active-icon' src={Assets.contact} alt='My Applications' />,
            activeIcon: <img className='active-icon' src={Assets.active_contact} alt='My Applications' />
        },
    ];

   const handleLogout = async () => {
  try {
    await PostAPI({ url: "/auth/doctor/logout"}, (res) => {
      console.log("Logout response:", res);
    });
  } catch (error) {
    console.error("Logout failed:", error);
  } finally {
    setUser({ type: "logout" });
    sessionStorage.removeItem("loggedIn");
    localStorage.removeItem("token");
    navigate("/");
  }
};


    return (
        <div className='layout-sec'>
            <div className='header-sec'>
                <img src={Assets.digi_logo} alt="Digi Logo" />
            </div>
            {/* <div className='serach-sec'>
                <input type="search" placeholder='Search' className='search-input bg-w' />
                <img src={Assets.search_icon} alt="Search" className='search-icon ' />
            </div> */}
            {/* sidebar */}
            <div className="sidebar">
                <div className='sidebar_content'>
                    {
                        menuItem.map((item, index) => (
                            <NavLink to={item.path} key={index} className="links mr-2" activeclassName="active" >
                                {item.icon}
                                {item.activeIcon}
                                <div style={isOpen ? { display: "block" } : { display: "none" }} className="link_text">{item.name}</div>
                            </NavLink>
                        ))
                    }
                    <div className='footer-sec' onClick={() => handleLogout()}>
                        <img src={Assets.logout_icon} alt="Logout Logo" />
                        <p className='log-txt'>Logout</p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default SideBar